import product_curated_team_routes from './product-curated-team-routes'

export default product_curated_team_routes